var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.5H34C35.1 16.5 36 17.4 36 18.5V38.5C36 39.6 35.1 40.5 34 40.5H2C0.9 40.5 0 39.6 0 38.5V18.5C0 17.4 0.9 16.5 2 16.5H4V14.5C4 6.76 10.26 0.5 18 0.5C25.74 0.5 32 6.76 32 14.5V16.5ZM4 20.5V36.5H32V20.5H4ZM28 16.5V14.5C28 8.98 23.52 4.5 18 4.5C12.48 4.5 8 8.98 8 14.5V16.5H28Z",
    fill: "{themeSvg}"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.317716c6f0af25a79c50de1b961a1e6e.svg";
export { ForwardRef as ReactComponent };